/* Max Your Stack — live "you save X%" estimate.
   Display-only add-on over the native product-bundle builder. Reads the
   rendered total + submit-enabled state (threshold == minimum_quantity),
   injects a Subtotal / You save X% / Est. total breakdown, and replaces the
   passive "discounts at checkout" line. The real discount is a Shopify
   automatic discount applied at checkout. No edits to product-bundle.liquid
   or theme.js. */
(function () {
  function num(text) {
    var n = parseFloat(String(text || '').replace(/[^0-9.,-]/g, '').replace(/,/g, ''));
    return isNaN(n) ? 0 : n;
  }
  function symbolOf(text) {
    var s = String(text || '').replace(/[\d.,\s-]/g, '');
    return s || '$';
  }
  function fmt(sym, amount) { return sym + amount.toFixed(2); }

  function setup(bundle, percent, minimum) {
    var totalEl = bundle.querySelector('[data-product-bundle-total]');
    var submit = bundle.querySelector('[data-product-bundle-submit]');
    var footer = bundle.querySelector('.product-bundle__footer');
    if (!totalEl || !submit || !footer || footer.querySelector('.stack-discount')) return;
    var atCheckout = footer.querySelector('p.text-opacity');

    var box = document.createElement('div');
    box.className = 'stack-discount';
    box.hidden = true;
    box.innerHTML =
      '<div class="stack-discount__row"><span>Subtotal</span><span data-sd="sub"></span></div>' +
      '<div class="stack-discount__row stack-discount__save"><span>You save ' + percent + '%</span><span data-sd="save"></span></div>' +
      '<div class="stack-discount__row stack-discount__total"><span>Estimated total</span><span data-sd="total"></span></div>';
    // A <div>, not a <p>: Concept hides every `.button[disabled] ~ p` in the
    // footer, which would force-hide the nudge at < threshold (button disabled).
    var nudge = document.createElement('div');
    nudge.className = 'stack-discount__nudge';
    nudge.textContent = 'Add ' + minimum + ' or more items to unlock ' + percent + '% off';

    if (atCheckout) {
      footer.insertBefore(box, atCheckout);
      footer.insertBefore(nudge, atCheckout);
      atCheckout.textContent = 'Discount applied automatically at checkout (estimated).';
    } else {
      footer.appendChild(box);
      footer.appendChild(nudge);
    }

    var sub = box.querySelector('[data-sd="sub"]');
    var save = box.querySelector('[data-sd="save"]');
    var tot = box.querySelector('[data-sd="total"]');

    function update() {
      var subtotal = num(totalEl.textContent);
      var sym = symbolOf(totalEl.textContent);
      var qualifies = !submit.disabled && subtotal > 0;
      if (qualifies) {
        var saving = subtotal * percent / 100;
        sub.textContent = fmt(sym, subtotal);
        save.textContent = '-' + fmt(sym, saving);
        tot.textContent = fmt(sym, subtotal - saving);
        box.hidden = false;
        nudge.hidden = true;
      } else {
        box.hidden = true;
        nudge.hidden = false;
      }
    }

    var mo = new MutationObserver(function () { update(); });
    mo.observe(totalEl, { childList: true, characterData: true, subtree: true });
    mo.observe(submit, { attributes: true, attributeFilter: ['disabled'] });
    bundle.addEventListener('click', function () { setTimeout(update, 60); });
    bundle.addEventListener('change', function () { setTimeout(update, 60); });
    update();
  }

  function init() {
    var cfg = document.querySelector('[data-stack-config]');
    var percent = cfg ? (parseInt(cfg.getAttribute('data-discount-percent'), 10) || 10) : 10;
    var minimum = cfg ? (parseInt(cfg.getAttribute('data-minimum'), 10) || 3) : 3;
    document.querySelectorAll('product-bundle').forEach(function (b) { setup(b, percent, minimum); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
